export default "__VITE_ASSET__7cb7732e__"